import ResponseDataExtractor from '../../../../common/utils/ResponseDataExtractor';
import helper from '../../../../helper';

export default {
	sendPasswordResetEmail({ commit }, email) {
        var AuthKeyStore = require('../../../../common/utils/AuthKeyStore');
        var key = new AuthKeyStore().retrievePassword();

        let url = process.env.MIX_API_URL + 'utility/password-reset';
        var body = { email : email };
        var options = { headers : { SecretToken : key }};

        axios.post(url, body, options)
            .then(response => new ResponseDataExtractor(response).data)
            .catch(e => {
                const { statusCode, error } = new ErrorHandle(e).format;
                if(statusCode == 408) {
                    axios.post(process.env.MIX_API_URL +  'utility/send-failed-api-notification', {
                        'request_uri': 'utility/password-reset'
                    });
                }
                console.log('Error when request reset password from api')
                var errorMessage = "Could not contact the server: " + error; // Default Message
                commit('SET_VALIDATE_EMAIL_RESULT', null);
                commit('SET_VALIDATE_EMAIL_ERROR', errorMessage);
            });
    },
    clearValidateEmailResult({commit}){
        commit('SET_VALIDATE_EMAIL_RESULT', null);
    },
    clearValidateEmailError({commit}){
        commit('SET_VALIDATE_EMAIL_ERROR', null);
    },
}